import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";

import VisitorHeader2 from "../../common_components/visitor_module_header2";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";

import HeaderWithLogo from "../../common_components/header_with_logo";
import ExhibitionDrawer from "../../common_components/admin_module_drawer";

import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";

import AgentHeader from "../../common_components/agent_module_header";
import AgentDrawer from "../../common_components/agent_module_drawer";
import AgentTopMenu from "../../common_components/agent_module_topmenu";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import Loader from "../../utils/Loader";

import { updatePassword_action } from "../../actions/user_login_auth_actions/user_login_auth_action";
import { BASE_URL, toastError, toastSuccess } from "../../utils/constants";
import { newPasswordValidator } from "../../utils/Validator";


class ChangePassword2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            is_showOldpass: false,
            is_showNewpass: false,
            is_showConfirmpass: false,
            old_pass: "",
            new_pass: "",
            confirm_pass: "",
            old_passErr: "",
            new_passErr: "",
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            confirm_passErr: "",
            isBackToLogin: false
        };

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.updatePassword()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    handleObscure(field) {
        this.setState(prev => ({
            [field]: !prev[field]
        }));
    }

    inputValidate() {
        const { old_pass, new_pass, confirm_pass } = this.state;

        if (!old_pass) this.setState({ old_passErr: "Please Enter Current Password" });
        if (!new_pass) this.setState({ new_passErr: "Please Enter New password" });
        if (!confirm_pass) this.setState({ confirm_passErr: "Please Enter Confirm Password" });

        if (new_pass) {
            const err = newPasswordValidator(new_pass);
            if (err) {
                this.setState({ new_passErr: err, old_pass: '', new_pass: '', confirm_pass: '', isBackToLogin: true });
                return false;
            }
        }

        if (new_pass !== confirm_pass) {
            this.setState({ confirm_passErr: "New password and Confirm password should be same" });
            return false;
        }

        return true;
    }

    updatePassword() {
        const UserID = this.props.location?.state?.UserID || null;

        if (!this.inputValidate()) return;

        this.setState({ isLoading: true });

        this.props.updatePassword_action(this.state.old_pass.trim(), this.state.new_pass.trim(), JSON.parse(sessionStorage.getItem("loginDataSS")).UserID)
            .then(data => {
                this.setState({ isLoading: false, old_pass: '', new_pass: '', confirm_pass: '', old_passErr: '', new_passErr: '', confirm_passErr: '', isBackToLogin: true });

                if (data.error != 1) {
                    toastSuccess("Password Changed Successfully");
                } else {
                    toastError(data.msg);
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    renderHeader(role) {
        switch (role) {
            case 1: return <ExhibitorHeader />;
            case 2: return <HeaderWithLogo />;
            case 3: return <VisitorHeader2 />;
            case 4: return <AgentHeader />;
            default: return null;
        }
    }

    renderDrawer(role) {
        switch (role) {
            case 1: return <ExhibitorDrawer />;
            case 2: return <ExhibitionDrawer />;
            case 3: return <VisitorDrawer />;
            case 4: return <AgentDrawer />;
            default: return null;
        }
    }

    renderTopMenu(role) {
        switch (role) {
            case 1: return <ExhibitorTopMenu />;
            case 3: return <VisitorTopMenu />;
            case 4: return <AgentTopMenu />;
            default: return null;
        }
    }

    render() {
        const {
            isLoading,
            old_pass, new_pass, confirm_pass,
            old_passErr, new_passErr, confirm_passErr, isBackToLogin,
            is_showOldpass, is_showNewpass, is_showConfirmpass, isOpenConfirmationModal
        } = this.state;

        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
        const RoleID = loginData?.RoleID;

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {/* {this.renderHeader(RoleID)}
                {this.renderDrawer(RoleID)} */}

                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '100%', maxWidth: '360px', margin: '0 15px' }}>
                        <div className="card shadow-sm border-0 position-relative" style={{ borderTop: '4px solid #00695c', borderRadius: '8px' }}>
                            {this.props.onClose && (
                                <i className="fa fa-times position-absolute" style={{ top: '15px', right: '15px', cursor: 'pointer', fontSize: '18px', color: '#999' }} onClick={this.props.onClose}></i>
                            )}
                            <div className="card-header bg-white border-0 pb-0 pt-4 px-4 text-start">
                                <div className="d-block w-100">
                                    <h5 className="mb-2" style={{ color: '#00695c', fontWeight: '700', fontSize: '18px' }}>Security Update</h5>
                                    <p className="text-secondary mb-0" style={{ fontSize: '12px', lineHeight: '1.4' }}>Ensure your account stays secure by choosing a strong password.</p>
                                </div>
                            </div>

                            <div className="card-body px-4 pb-4">
                                <form autoComplete="off">
                                    {!isBackToLogin ?
                                        <>
                                            {/* Old Password */}
                                            <div className="form-group mb-3 position-relative text-start">
                                                <label style={{ fontSize: '12px', fontWeight: '600', color: '#4b5563', marginBottom: '6px' }}>Current Password</label>
                                                <input
                                                    type={is_showOldpass ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter Your Old Password"
                                                    value={old_pass}
                                                    onChange={e => this.setState({ old_pass: e.target.value, old_passErr: "" })}
                                                    style={{ fontSize: '13px', padding: '10px 12px' }}
                                                />
                                                <span className="text-danger">{old_passErr}</span>

                                                <i className={is_showOldpass ? "fa fa-eye-slash" : "fa fa-eye"}
                                                    onClick={() => this.handleObscure("is_showOldpass")}
                                                    style={{ position: "absolute", top: 35, right: 12, color: "#9ca3af", cursor: 'pointer', fontSize: '15px' }}
                                                />
                                            </div>

                                            {/* New Password */}
                                            <div className="form-group mb-3 position-relative text-start">
                                                <label style={{ fontSize: '12px', fontWeight: '600', color: '#4b5563', marginBottom: '6px' }}>New Password</label>
                                                <input
                                                    type={is_showNewpass ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter New Password"
                                                    maxLength="20"
                                                    value={new_pass}
                                                    onChange={e => this.setState({ new_pass: e.target.value, new_passErr: "" })}
                                                    style={{ fontSize: '13px', padding: '10px 12px' }}
                                                />
                                                <span className="text-danger">{new_passErr}</span>

                                                <i className={is_showNewpass ? "fa fa-eye-slash" : "fa fa-eye"}
                                                    onClick={() => this.handleObscure("is_showNewpass")}
                                                    style={{ position: "absolute", top: 35, right: 12, color: "#9ca3af", cursor: 'pointer', fontSize: '15px' }}
                                                />
                                            </div>

                                            {/* Confirm Password */}
                                            <div className="form-group mb-4 position-relative text-start">
                                                <label style={{ fontSize: '12px', fontWeight: '600', color: '#4b5563', marginBottom: '6px' }}>Confirm Password</label>
                                                <input
                                                    type={is_showConfirmpass ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter New Password again"
                                                    maxLength="20"
                                                    value={confirm_pass}
                                                    onChange={e => this.setState({ confirm_pass: e.target.value, confirm_passErr: "" })}
                                                    style={{ fontSize: '13px', padding: '10px 12px' }}
                                                />
                                                <span className="text-danger">{confirm_passErr}</span>

                                                <i className={is_showConfirmpass ? "fa fa-eye-slash" : "fa fa-eye"}
                                                    onClick={() => this.handleObscure("is_showConfirmpass")}
                                                    style={{ position: "absolute", top: 35, right: 12, color: "#9ca3af", cursor: 'pointer', fontSize: '15px' }}
                                                />
                                            </div>

                                            <button
                                                type="button"
                                                className="btn w-100"
                                                // onClick={() => this.updatePassword()}
                                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                                style={{ backgroundColor: '#3cbba7', color: 'white', padding: '12px', borderRadius: '6px', fontWeight: '600', fontSize: '14px' }}
                                            >
                                                <i className="fa fa-shield me-2"></i> Change Password
                                            </button>
                                        </> :
                                        <div
                                            className="text-center mt-2 text-aqua"
                                            style={{ fontSize: '18px', textDecoration: 'underline' }}
                                            onClick={() => {
                                                sessionStorage.clear();
                                                window.location.href = BASE_URL.replace('/api', '');
                                            }}
                                        >
                                            Back To Login
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(null, { updatePassword_action })(ChangePassword2));
